import Select from 'react-select';
/**
 * WordPress dependencies
 */
const { useState } = wp.element;
const { useSelect } = wp.data;

const WCProductCategorySelect = (props) => {
	const [searchKeyword, setSearchKeyword] = useState('');

	const { data, isRequesting } = useSelect(
		(select) => {
			const { isResolving } = select('core/data');

			const params = {
				per_page: 10,
				search: searchKeyword
			};

			return {
				data: select('core').getEntityRecords('taxonomy', 'product_cat', params),
				isRequesting: isResolving('core', 'getEntityRecords', ['taxonomy', 'product_cat', params])
			};
		},
		[searchKeyword]
	);

	const options =
		data?.map((term) => ({
			label: `${term.name} (ID: ${term.id})`,
			value: term.id
		})) || [];

	return (
		<div>
			<Select
				classNamePrefix='conditional-blocks-select'
				className='conditional-blocks-select-container'
				isSearchable
				isLoading={isRequesting}
				options={options}
				onInputChange={(val) => setSearchKeyword(val)}
				{...props}
			/>
		</div>
	);
};

export default WCProductCategorySelect;
